import { render } from 'react-dom';
import ReactModal from 'react-modal';

import App from './app/App';
import './assets/css/tailwind.css';

render(<App />, document.getElementById('root'));
ReactModal.setAppElement('#root');
